export default __webpack_public_path__ + "static/media/2088.88fbefae.png";